import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'client-strip',
  templateUrl: './client-strip.component.html',
  styleUrls: ['./client-strip.component.css']
})
export class ClientStripComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/widget/client-strip/client-strip.component.ts